// File 1: src/pages/ReturnToVendor/ReturnToVendor.tsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UseDebounce } from "../../../states/Hooks/UseDebounce";
import { useLoading } from "../../../views/Loader/LoadingContext";
import SideBarNavigation from "../../Layouts/Sidebar/Sidebar";
import AllReturnTableComponent from "../../Layouts/Table/AllReturnsTableComponent";
import CustomDropdown from "../CustomDropdown/CustomDropdown";

const returnOrderStatusOptions = [
  { value: "", label: "All" },
  { value: "DRAFT", label: "Draft" },
  { value: "COMPLETED", label: "Completed" },
];

function AllReturnOrders() {
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const debouncedSearch = UseDebounce(search, 500);

  useEffect(() => {
    setPage(0);
  }, [debouncedSearch]);

  return (
    <div className="flex h-screen bg-gray-50">
      <div className="w-64 bg-white shadow-lg">
        <SideBarNavigation />
      </div>

      <div className="flex-1 p-6 ml-6 overflow-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-semibold text-gray-900">
            Returned Orders
          </h1>
        </div>

        {/* Filters and Search */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
          <div className="flex items-center gap-4">
            <CustomDropdown
              label="Status:"
              options={returnOrderStatusOptions}
              value={statusFilter}
              onChange={setStatusFilter}
              minWidth="130px"
            />
          </div>

          <div className="flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="Search by order number"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg w-80 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              <svg
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200">
          <AllReturnTableComponent
            currentPage={page}
            setCurrentPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            search={debouncedSearch}
            statusFilter={statusFilter}
          />
        </div>
      </div>
    </div>
  );
}

export default AllReturnOrders;
